import { createLucideIcon } from "lucide-react";

export const UserMultiple = createLucideIcon(
    "UserMultiple",
    [
        [
            "path",
            {
                d: "M13 7.5C13 9.70914 11.2091 11.5 9 11.5C6.79086 11.5 5 9.70914 5 7.5C5 5.29086 6.79086 3.5 9 3.5C11.2091 3.5 13 5.29086 13 7.5Z",
                key: "1k2i3s",
            },
        ],
        [
            "path",
            {
                d: "M15.5 5.0688C15.7271 5.0237 15.9629 5 16.2048 5C18.0247 5 19.5 6.3431 19.5 8C19.5 9.6569 18.0247 11 16.2048 11C15.9629 11 15.7271 10.9763 15.5 10.9312",
                key: "162vy2",
            },
        ],
        [
            "path",
            {
                d: "M18.6161 20H19.1063C20.2561 20 21.1707 19.4761 21.9919 18.7436C24.078 16.8826 19.1741 15 17.5 15",
                key: "qcd74u",
            },
        ],
        [
            "path",
            {
                d: "M4.48131 16.1112C3.30234 16.743 0.211137 18.0331 2.09388 19.6474C3.01359 20.436 4.03791 21 5.32572 21H12.6743C13.9621 21 14.9864 20.436 15.9061 19.6474C17.7889 18.0331 14.6977 16.743 13.5187 16.1112C10.754 14.6296 7.24599 14.6296 4.48131 16.1112Z",
                key: "1361kt",
            },
        ],
    ],
);
